/**
 * MenuContentContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled container for the menu content.
 */
const MenuContentContainer = styled.div`
  height: max-content;
  position: relative;
  top: ${238 * Screen.widthRatio}px;
`;

export default MenuContentContainer;
